import { CustomerIcon } from "@/components/CustomerIcon";
import SubLayout from "@/components/SubLayout";
import { Payments, PaymentsMappingStr } from "@/constants";
import { Button, Form } from "antd-mobile";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FormMap } from "./forms";
import { useSetup } from "./logic";

export function PagePaymentAdd() {
  const logic = useSetup();

  const FormContent = useMemo(
    () => FormMap[`${logic.type}`] || null,
    [logic.type]
  );

  return (
    <SubLayout
      title={`添加${PaymentsMappingStr[Number(logic.type) as Payments]}`}
      footer={
        <div>
          <div className={"tip-content"}>
            <Guide type={Number(logic.type)} />
          </div>
          <Button
            className={"common-submit-button"}
            onClick={() => {logic.onSubmit()}}
            loading={logic.add.loading}
          >
            确定添加
          </Button>
        </div>
      }
    >
      {FormContent ? (
        <Form form={logic.form} className={"common-form"}>
          <FormContent
            codeImage={logic.state.verifyCode}
            onUpload={async (file) => {
              const path = await logic.uploadQRcode(file);
              return path ? path : "";
            }}
            flushCodeImage={logic.flushCodeImage}
          />
        </Form>
      ) : null}
    </SubLayout>
  );
}

const Guide = ({ type }: { type: Payments }) => {
  const navigate = useNavigate();
  switch (type) {
    case Payments.BANK:
      return (
        <>
          如需帮助，请{" "}
          <CustomerIcon className={"tip-content-icon"}>
            <span className={"tip-content-link"}>{" 联系客服 "}</span>
          </CustomerIcon>
        </>
      );
    case Payments.CRYPTO_COIN:
      return null;
      case Payments.DIGITAL_RMB:
        return null;
    default:
      return (
        <>
          如何保存
          <span
            className={"tip-content-link"}
            onClick={() => navigate(`/how_to_save_receive_code/${type}`)}
          >
            收款码
          </span>
        </>
      );
  }
};
